module.exports = __webpack_public_path__ + "assets/img/ms.52f07847.png";